var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 2.6665C10.8413 2.6665 6.66797 6.83984 6.66797 11.9998C6.66797 18.9998 16.0013 29.3332 16.0013 29.3332C16.0013 29.3332 25.3346 18.9998 25.3346 11.9998C25.3346 6.83984 21.1613 2.6665 16.0013 2.6665ZM16.0013 15.3332C14.1613 15.3332 12.668 13.8398 12.668 11.9998C12.668 10.1598 14.1613 8.6665 16.0013 8.6665C17.8413 8.6665 19.3346 10.1598 19.3346 11.9998C19.3346 13.8398 17.8413 15.3332 16.0013 15.3332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.91b00fed60ce582281cf018d1e3b1cff.svg";
export { ForwardRef as ReactComponent };